module.exports = __webpack_public_path__ + "static/media/hub_4_4k.d2cee8eb.png";